import { HIRING_CONTACTS_DATA } from './hiringContacts.generated';

export interface HiringContact {
  firstName: string;
  lastName: string;
  url: string;
  company: string;
  position: string;
  keywords: string[];
}

export const HIRING_CONTACTS: HiringContact[] = HIRING_CONTACTS_DATA;
